import React from 'react';

export default function CandySprinklesSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Sprinkles scattered across the area - rounded rects at various angles */}
      {/* Pink sprinkles */}
      <rect x="6" y="10" width="4" height="1.6" rx="0.8" fill="#FF80AB" transform="rotate(30 8 10.8)" />
      <rect x="22" y="8" width="4" height="1.6" rx="0.8" fill="#F06292" transform="rotate(-20 24 8.8)" />
      <rect x="14" y="20" width="4" height="1.6" rx="0.8" fill="#FF80AB" transform="rotate(60 16 20.8)" />
      <rect x="28" y="22" width="4" height="1.6" rx="0.8" fill="#F06292" transform="rotate(-40 30 22.8)" />
      <rect x="8" y="30" width="4" height="1.6" rx="0.8" fill="#FF4081" transform="rotate(15 10 30.8)" />
      {/* Yellow sprinkles */}
      <rect x="14" y="6" width="4" height="1.6" rx="0.8" fill="#FFD740" transform="rotate(-30 16 6.8)" />
      <rect x="30" y="12" width="4" height="1.6" rx="0.8" fill="#FFEA00" transform="rotate(45 32 12.8)" />
      <rect x="4" y="22" width="4" height="1.6" rx="0.8" fill="#FFD740" transform="rotate(-15 6 22.8)" />
      <rect x="20" y="28" width="4" height="1.6" rx="0.8" fill="#FFEA00" transform="rotate(70 22 28.8)" />
      <rect x="26" y="32" width="4" height="1.6" rx="0.8" fill="#FFD740" transform="rotate(-50 28 32.8)" />
      {/* Blue sprinkles */}
      <rect x="18" y="14" width="4" height="1.6" rx="0.8" fill="#40C4FF" transform="rotate(80 20 14.8)" />
      <rect x="2" y="16" width="4" height="1.6" rx="0.8" fill="#82B1FF" transform="rotate(-60 4 16.8)" />
      <rect x="32" y="28" width="4" height="1.6" rx="0.8" fill="#40C4FF" transform="rotate(25 34 28.8)" />
      <rect x="16" y="34" width="4" height="1.6" rx="0.8" fill="#82B1FF" transform="rotate(-25 18 34.8)" />
      <rect x="10" y="16" width="4" height="1.6" rx="0.8" fill="#40C4FF" transform="rotate(50 12 16.8)" />
      {/* A few dots for variety */}
      <circle cx="24" cy="18" r="0.9" fill="#FF4081" />
      <circle cx="6" cy="36" r="0.8" fill="#FFEA00" />
      <circle cx="36" cy="36" r="0.8" fill="#40C4FF" />
    </svg>
  );
}
